var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1561 21.8761H48C47.4816 16.118 45.1605 11.1268 41.0368 6.90265C36.9131 2.67847 31.9529 0.377581 26.1561 0V21.8761ZM21.9146 48V0C15.7408 0.519174 10.5449 3.09145 6.32695 7.71681C2.10898 12.3422 0 17.7699 0 24C0 30.2301 2.10898 35.6578 6.32695 40.2832C10.5449 44.9086 15.7408 47.4808 21.9146 48ZM26.1561 48C31.9529 47.6224 36.9131 45.3215 41.0368 41.0973C45.1605 36.8732 47.4816 31.882 48 26.1239H26.1561V48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteReports);
export default __webpack_public_path__ + "static/media/whiteReports.2b99b3c7c773551810b7722606f12758.svg";
export { ForwardRef as ReactComponent };